import { gql } from "@apollo/client";

export default gql`
  mutation deleteAiMessagesByDateRange($data: DeleteByDateRangeParams!){
    deleteAiMessagesByDateRange(data: $data){
        success
        data{
            deletedCount
            deletedSteps
        }
        code
        message
    }
}
`
